














































































































































































































































































































































































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { ListParameters, ListResult, ResultRow, TimeEntryViewModel } from "@/services/api/nswag/stapiclient_generated";
import { PagerRow } from "@/views/List/listrow";
import ListPager from "@/views/List/ListPager.vue";
import { UserStore } from "@/store/user-module";
import StarRating from "vue-star-rating";
import StBadge from "@/components/basic/StBadge.vue";
import StSupBadge from "@/components/basic/StSupBadge.vue";
import {notifyError, notifySuccess} from '@/utlitities/notifications';
import {DateTime} from 'luxon';

@Component({
  components: { StSupBadge, StBadge, ListPager, StarRating }
})
export default class ListTable extends Vue {
  @Prop() listParams?: ListParameters;
  @Prop() listResult?: ListResult;
  @Prop() isExport!: boolean;
  @Prop() toggleClearedLoadingId!: number;
  @Prop() deleteLoadingId!: number;

  queryParams: ListParameters = ListParameters.fromJS({ filter: {}, grouping: {}, listSettingsModel: {} });
  queryResult: ListResult = ListResult.fromJS({ rows: [] });

  page: number = 1;
  pageSize: number = 50;
  pageIsChanging: boolean = false;

  private showLockAll: boolean = false;

  @Watch("listParams")
  changeListParams() {
    this.page = 1;
  }

  async changePage(value: number) {
    this.pageIsChanging = true;
    await this.$nextTick();
    this.page = value;
    this.pageIsChanging = false;
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  getExtraFieldDataType(row: ResultRow, extraFieldName: string) {
    return row.timeEntry?.timeEntryExtraFields?.find((x) => x.description == extraFieldName)?.dataType;
  }

  getExtraFieldValue(row: ResultRow, extraFieldName: string) {
    let extraField = row.timeEntry?.timeEntryExtraFields?.find((x) => x.description == extraFieldName);
    let value = extraField?.value;
    if (value && extraField?.dataType === "YesNo") {
      return value.toLowerCase() === "true" ? this.$t("Ja") : this.$t("Nein");
    }

    return value;
  }

  getExtraFieldColumnWidth(id: number) {
    const res = this.listParams?.listSettingsModel?.extraFieldColumnLayout?.find((x) => x.id == id)?.width;

    if (!res) {
      return "auto";
    }

    return res + "%";
  }

  getColumnWidth(column: string) {
    const res = this.listParams?.listSettingsModel?.columnLayout?.find((x) => x.columnName == column)?.width;

    if (!res) {
      return "auto";
    }

    return res + "%";
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get canClearEntries() {
    return UserStore.userSettings.CanClearEntries;
  }

  get params(): ListParameters {
    return this.listParams ?? this.queryParams;
  }

  get sortDateAscending() {
    return this.listSettings?.sortDateAscending;
  }

  @Emit("toggleDateSort")
  toggleSortDateAscending() {
    return;
  }

  get pagedRows(): ResultRow[] {
    if (!this.result.rows || !this.result.rows.length) return [];

    let contentRows = this.result.rows.filter((_) => !_.isSum);

    let startIndex = this.isExport ? 0 : (this.page - 1) * this.pageSize;
    let endIndex = this.isExport ? contentRows.length : this.page * this.pageSize;

    let rows = contentRows.slice(startIndex, endIndex).map((_) => {
      return _;
    });

    //Summenzeile immer am Anfang und am Ende einfügen
    rows.unshift(this.result.rows[0]);
    rows.push(this.result.rows[0]);

    return rows;
  }

  get containsNotBillableEntries(): boolean {
    let sumRows = this.result.rows.filter(_=>_.isSum);
    if (sumRows.length)
    {
      return sumRows[0].durationMinutesSumNotBillable != 0;
    }

    return false;
  }

  get pager(): PagerRow | null {
    if (this.pagedRows.length == this.result.rows!.length) {
      return null;
    }

    let pagerRow = new PagerRow();
    pagerRow.page = this.page;
    pagerRow.visibleItems = this.pagedRows.length - 2;
    pagerRow.totalItems = this.result.rows!.length - 2;
    pagerRow.remainingItems = 2;
    pagerRow.totalPages = Math.ceil((this.result.rows!.length - 2) / this.pageSize);

    return pagerRow;
  }

  get result(): ListResult {
    return this.listResult ?? this.queryResult;
  }

  get filter() {
    return this.params.filter;
  }

  get grouping() {
    return this.params.grouping;
  }

  get listSettings() {
    return this.params.listSettingsModel;
  }

  get displayDateColumn(): boolean {
    if (!this.grouping) {
      return true;
    }

    if (!this.grouping.day && !this.grouping.week && !this.grouping.month && !this.grouping.year && this.columnIsVisible("date")) {
      return true;
    }

    return !!(!this.grouping.day && (this.grouping.week || this.grouping.month || this.grouping.year) && this.columnIsVisible("date"));
  }

  get numberOfReducingGroups(): number {
    let number = 0;

    if (this.grouping?.day || this.grouping?.week || this.grouping?.month || this.grouping?.year) {
      number++;
    }
    if (this.grouping?.customer) {
      number++;
    }
    if (this.grouping?.project) {
      number++;
    }
    if (this.grouping?.user) {
      number++;
    }
    if (this.grouping?.projectTask) {
      number++;
    }

    return number;
  }

  get groupColSpan(): number {
    let colspan = this.isExport ? 9 : 10; //Maximalausprägung bei 5 Gruppen

    if (!this.columnIsVisible("projecttask") && !this.grouping?.projectTask) {
      colspan--;
    }

    if (!this.columnIsVisible("project") && !this.grouping?.project) {
      colspan--;
    }

    if (!this.columnIsVisible("customer") && !this.grouping?.customer) {
      colspan--;
    }

    if (!this.columnIsVisible("appuser") && !this.grouping?.user) {
      colspan--;
    }

    if (!this.columnIsVisible("date") && !this.grouping?.day && !this.grouping?.week && !this.grouping?.month && !this.grouping?.year) {
      colspan--;
    }

    if (!this.columnIsVisible("description")) {
      colspan--;
    }

    if (!this.columnIsVisible("rate")) {
      colspan--;
    }

    if (!this.columnIsVisible("timefromtocol")) {
      colspan--;
    }

    if (!this.columnIsVisible("labelscol")) {
      colspan--;
    }

    this.listResult?.extraFieldHeaderColumns?.forEach((x) => {
      if (this.extraFieldColumnIsVisible(x.id!)) {
        colspan++;
      }
    });

    return colspan;
  }

  @Emit("toggleCleared")
  toggleCleared(id: number) {
    return id;
  }

  @Emit("toggleClearedAll")
  toggleClearedAll(newvalue: boolean) {
    this.showLockAll = false;
    return newvalue;
  }

  editTimeEntry(entry: TimeEntryViewModel) {
    if (!entry.isDisabled) {
      this.$emit("editTimeEntry", entry.id);
    }
  }

  @Emit("deleteItem")
  deleteItem(id: number) {
    return id;
  }

  extraFieldColumnIsVisible(id: number): boolean {
    return this.listSettings?.visibleExtraFieldIds?.some((x) => x == id) ?? false;
  }

  columnIsVisible(column: string): boolean {
    if ((column == "rate" || column == "revenue") && !this.canViewRates) {
      return false;
    }

    if (this.listSettings?.hiddenColumns?.length && this.listSettings.hiddenColumns.indexOf(column) !== -1) {
      return false;
    }

    return true;
  }

  copyDescription(event: PointerEvent, timeEntry: TimeEntryViewModel, withModifier: boolean = false)
  {
    let copyText = '';

    if (event.ctrlKey)
    {
      copyText += DateTime.fromISO(timeEntry.entryDate).toFormat("dd.MM.yyyy") + '\n';
    }

    if (timeEntry.isInputTimeFromTo && this.columnIsVisible('timefromto'))
    {
      copyText += timeEntry.timeFrom + ' - ' + timeEntry.timeTo + '\n';
    }

    copyText += timeEntry.description ?? '';

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(copyText);
      notifySuccess(this.$t('Beschreibung kopiert').toString());
    } else {
      notifyError('Fehler beim kopieren')
    }
  }
}
